<template>
    <div class="table-responsive mt-3">
        <table class="table table-striped" v-bind:class="{ datatable: dataTable }">
            <thead>
            <tr>
                <th v-for="header in data.headers" :key="header.columnIndex">
                    {{ header.value }}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in data.rows" :key="row.rowIndex">
                <td v-for="rowValue in row.values" :key="rowValue.columnIndex">
                    {{ rowValue.value }}
                </td>
            </tr>
            <slot name="additionalRows"/>
            </tbody>
        </table>
    </div>
</template>
<script>

    import JQuery from 'jquery'
    import dt from 'datatables.net-bs4';
    let $ = JQuery;

    export default {
        props: {
            data: {
                headers: [],
                rows: []
            },
            dataTable: Boolean
        },
        data: function () {
            return {
            }
        },
        mounted() {
            if(this.dataTable) {
                $(document).ready(function () {
                    $('.datatable').DataTable();
                });
            }
        },
        methods: {}
    }
</script>
<style scoped lang="scss">

    @import "../../sass/variables";
    // DataTables
    @import "~datatables.net-bs4/css/dataTables.bootstrap4.min.css";
    @import "~datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
    @import '~datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
    @import '~datatables.net-select-bs4/css/select.bootstrap4.min.css';
</style>
